import React, { Fragment, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import TextField from "@material-ui/core/TextField";
import DateFnsUtils from "@date-io/date-fns";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Parser from "html-react-parser";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import PostAddIcon from "@material-ui/icons/PostAdd";
import AisActionItem from "./aisActionItem";
import NormalDialog from "../../../Dialog/NormalDialog";
import AisAddActionItem from "./aisAddActionItem";
import { addAISActionItem } from "../../../../dataSource/ais";
// Material-UI Core
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { aisDetailFormStyle } from "../../../../styles/jss/components/AIS/aisDetailFormStyle";
const useStyles = makeStyles((theme) => aisDetailFormStyle(theme));
const AisCategory = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const store = require("store");
  const [selectEditDialogOpen, setSelectEditDialogOpen] = useState(false);
  const [selectAddDialogOpen, setSelectAddDialogOpen] = useState(false);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [confirmDialogData, setConfirmDialogData] = useState({
    dialogTitle: "",
    dialogContent: "",
    confirmAction: "",
    cancelAction: "",
  });
  const [addItem, setAddItem] = useState();
  const [addCategoryItem, setAddCategoryItem] = useState();
  const { obj, setUpdateFlag, updateFlag } = props;

  // Build Confirm Dialog
  const confirmDialogHandleOpen = (data) => {
    setConfirmDialogData({
      dialogTitle: data.dialogTitle,
      dialogContent: data.dialogContent,
      confirmAction: data.confirmAction,
      cancelAction: data.cancelAction,
    });

    setConfirmDialogOpen(true);
  };

  const confirmDialogHandleClose = () => {
    setConfirmDialogOpen(false);
  };
  const selectAddHandleOpen = () => {
    setSelectAddDialogOpen(true);
  };

  const selectAddHandleClose = () => {
    setSelectAddDialogOpen(false);
  };

  const cancelAction = () => {
    confirmDialogHandleClose();
  };

  const addActionItemConfirm = () => {
    confirmDialogHandleOpen({
      dialogTitle: "Add Action Item",
      dialogContent: "Are you sure to add this Action Item?",
      confirmAction: () => addActionItemAction(addItem),
      cancelAction: cancelAction,
    });
  };

  const addActionItemAction = (addItem) => {
    let body = [];
    body.push(addItem);
    let insertBody = { items: body, bySeq: "N" };
    addAISActionItem(insertBody).then((res) => {
      selectAddHandleClose();
      confirmDialogHandleClose();
      setUpdateFlag(!updateFlag);
    });
  };

  const addDialogBtn = [
    {
      buttonName: "Save",
      buttonFunction: addActionItemConfirm,
    },
    {
      buttonName: "Close",
      buttonFunction: selectAddHandleClose,
    },
  ];

  const addActionItem = (obj) => {
    let addBody = {
      action_item_seq: null,
      ais_cat_seq: obj.ais_cat_seq,
      actionBy: null,
      item_seq:
        obj.actionItem.length > 0
          ? Number(obj.actionItem[Number(obj.actionItem.length) - 1].item_seq) +
            1
          : 10001,
      title: null,
      notes: null,
      flag: "NEW",
      status: "In Progress",
      description: null,
      template: "N",
      targetcompletiondate: null,
    };
    setAddItem(addBody);
    selectAddHandleOpen();
  };

  const addCategory = (obj) => {};

  return (
    <Fragment>
      <NormalDialog
        open={selectAddDialogOpen}
        dialogTitle={`Add Action Item`}
        formContent={
          <AisAddActionItem
            addItem={addItem}
            setAddItem={setAddItem}
            confirmDialogData={confirmDialogData}
            confirmDialogOpen={confirmDialogOpen}
          />
        }
        size={"lg"}
        height={850}
        button={addDialogBtn}
        handleClose={selectAddHandleClose}
      />
      <div className={classes.titleDiv}>
        <div>
          <Typography style={{ padding: "15px" }}>{obj.title}</Typography>
          <span style={{ fontSize: "10px" }}>
            {obj.description === null ? "" : Parser(obj.description)}
          </span>
        </div>

        <div>
          {/* <Tooltip title="Add Category">
            <IconButton
              aria-label="add"
              onClick={() => {
                addCategory(obj);
              }}
            >
              <AddCircleIcon />
            </IconButton>
          </Tooltip> */}

          <Tooltip title="Add Action Item">
            <IconButton
              aria-label="add"
              onClick={() => {
                addActionItem(obj);
              }}
            >
              <PostAddIcon />
            </IconButton>
          </Tooltip>
        </div>
      </div>
      {
        <AisActionItem
          item={obj.actionItem}
          updateFlag={updateFlag}
          setUpdateFlag={setUpdateFlag}
        />
      }
    </Fragment>
  );
};
export default AisCategory;
